/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useRef } from "react";
import AppModal from "../feedBacks/AppModal";
import { CARD_TITLE } from "../../utils/constants";
import { ButtonType, TextInputType } from "../../enums/componentEnums";
import AnimatedInput from "../Inputs/AppAnimatedInput";
import AppButton from "../Inputs/AppButton";
import * as Yup from "yup";
import AppSelect2 from "../Inputs/AppSelect2";
import useCustomFormik from "../../customHooks/useFormik";
import { usePostData } from "../../customHooks/usePostData";
import { enqueueSnackbar } from "notistack";
import { assetTypeOptions } from "../../utils/utils";
import YearPicker from "../Inputs/DatePickerCustom";
import { IDevice, IZonesResponse } from "../../utils/interfaces";
import { useQueryClient } from "@tanstack/react-query";
import AppToggleInput from "../Inputs/ToggleInputs";

import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  useMap,
} from "react-leaflet";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import { useFetchData } from "../../customHooks/useGetDashboardData";

// Custom component to handle map center updates
function MapCenterUpdater({ center }: { center: [number, number] }) {
  const map = useMap();
  map.setView(center, 15);
  return null;
}

function LocationMarker({
  setFieldValue,
  position,
  setPosition,
}: {
  setFieldValue: (name: string, value: any) => void;
  position: [number, number] | null;
  setPosition: (position: [number, number] | null) => void;
}) {
  useMapEvents({
    click(e) {
      // console.log('CheckingAddress', e)
      const { lat, lng } = e.latlng;
      setPosition([lat, lng]);
      setFieldValue("latitude", lat);
      setFieldValue("longitude", lng);
      // setFieldValue("co_ordinate", `${lat}, ${lng}`);
    },
  });

  return position ? <Marker position={position} /> : null;
}

function AddDeviceModal({
  isModalOpen,
  closeModal,
  enableOutsideClick = true,
  company_id,
  type,
  data,
}: // data
{
  isModalOpen: boolean;
  closeModal: () => void;
  enableOutsideClick?: boolean;
  company_id?: string;
  type: "add" | "edit";
  data?: IDevice;
}) {
  const queryClient = useQueryClient();
  const [position, setPosition] = useState<[number, number] | null>(null);
  const [mapCenter, setMapCenter] = useState<[number, number]>([
    6.5244, 3.3792,
  ]);
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [showResults, setShowResults] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const provider = useRef(new OpenStreetMapProvider());
  const searchContainerRef = useRef<HTMLDivElement>(null);

  const transformDateToYear = (date: any) =>
    date instanceof Date ? date.getFullYear() : date;

  const initialValues =
    type === "edit" && data
      ? {
          ...data,
          transformer_year: transformDateToYear(data.transformer_year),
          is_active: data.is_active,
          asset_type: data.asset_type || assetTypeOptions[0].value,
          // co_ordinate: `${data.latitude}, ${data.longitude}`
        }
      : {
          asset_name: "",
          asset_type: assetTypeOptions[0].value,
          asset_capacity: "",
          gateway_serial: "",
          description: "",
          tariff: "",
          transformer_year: "",
          address_of_tfo: "",
          type_of_position: "",
          nature_of_position: "",
          nature_of_transformer: "",
        company_id,
          zone_id: "",
          // co_ordinate: "",
          latitude: "",
          longitude: "",
          is_active: true,
          search_address: "",
        };

  const validationSchema = Yup.object({
    asset_name: Yup.string().required("Device name is required"),
    asset_type: Yup.string().required("Asset Type is required"),
    // co_ordinate: Yup.string().required("co ordinate is required"),
    description: Yup.string().optional().nullable(),
    address_of_tfo: Yup.string().optional().nullable(),
    type_of_position: Yup.string().optional().nullable(),
    nature_of_position: Yup.string().optional().nullable(),
    company_id:
      type === "edit"
        ? Yup.string()
        : Yup.string().required("Company ID is required"),
    gateway_serial: Yup.string().required("Gateway serial is required"),
    tariff: Yup.number().required("Tariff is required"),
    transformer_year: Yup.string().required("Year of manufacture is required"),
    latitude: Yup.number(),
    longitude: Yup.number(),
    zone_id: Yup.string().required("Kindly select a zone"),
    nature_of_transformer: Yup.string(),
    asset_capacity: Yup.number().required("Asset capacity is required"),
    is_active: Yup.boolean().required("Device status is required"),
  });

  const onSubmit = (values: any) => {
    mutate(values);
  };

  const {
    handleSubmit,
    values,
    getFieldProps,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    resetForm,
    setSubmitting,
    setValues,
  } = useCustomFormik({ initialValues, validationSchema, onSubmit });

  const { mutate} = usePostData(
    type === "edit" ? `/device/${data?.id}` : "/devices",
    type === "edit" ? "PUT" : "POST",
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: ["/map", "fetchSiteMap", data.company.id],
        });
        queryClient.invalidateQueries({
          queryKey: ["/devices", "fetchAllDevices", data.company.id],
        });

        queryClient.invalidateQueries({
          queryKey: ["/manager", "fetchManager", data.company.id],
        });
       

        enqueueSnackbar(type === "edit" ? "Device updated" : "Device added!", {
          variant: "success",
        });
        resetForm();
        setSubmitting(false);
        closeModal();
      },
      onError: (err) => {
        const errorMessages = Object.values(err.response?.data || {})
          .flat() // Flatten arrays of errors
          .join(" "); // Join all messages into a single string
        enqueueSnackbar(errorMessages || "Error adding Device", {
          variant: "error",
        });
        setSubmitting(false);
      },
    }
  );

  const {
    data: zoneData,
    // isLoading: isZoneDataLoading,
    error:zoneDataError,
    // refetch,
  } = useFetchData<IZonesResponse>(
    ["/zones-by-company-id", "fetchAllZones", company_id],
    "/zones",
    {
      company_id,
    },
    {
      // @ts-ignore
      keepPreviousData: true,
      // staleTime: 30000,
    }
    );
  
  const transformedZoneData = zoneData?.results.map((item) => ({
    label: item.name,
    value: item.id,
    key: item.id,
  })) ?? [];
  const handleCoordinateInput = (value: string) => {
    // Update the form field value
    // setFieldValue("co_ordinate", value);

    // Try to parse the coordinates and update map center if valid
    try {
      const coordsString = value.trim();
      const [lat, lng] = coordsString
        .split(",")
        .map((coord) => parseFloat(coord.trim()));

      // Check if we have valid numbers
      if (!isNaN(lat) && !isNaN(lng)) {
        setFieldValue("latitude", lat);
        setFieldValue("longitude", lng);
        setPosition([lat, lng]);
        setMapCenter([lat, lng]);
      }
    } catch (error) {
      console.error("Error parsing coordinates:", error);
      // Invalid format - don't update map
    }
  };
  useEffect(() => {
    if (type === "edit" && data) {
      setValues({
        ...data,
        company_id: data.company.id,
        transformer_year: transformDateToYear(data.transformer_year),
      });

      // If there are coordinates in the data, set the position and map center
      if (data.latitude && data.longitude) {
        const lat = data.latitude;
        const lng = data.longitude;
        try {
          setPosition([lat, lng]);
          setMapCenter([lat, lng]);
        } catch (error) {
          console.error("Error parsing coordinates:", error);
        }
      }
    }
  }, [data, type, setValues]);

  // jQuery to handle click outside search results
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target as Node)
      ) {
        setShowResults(false);
      }
    }

    // Add event listener when dropdown is shown
    if (showResults) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showResults]);
  // Handle address search
  const handleAddressSearch = async (query: string) => {
    setSearchQuery(query);

    if (query.length > 2) {
      try {
        const results = await provider.current.search({ query });
        setSearchResults(results);
        setShowResults(true);
      } catch (error) {
        console.error("Error searching for address:", error);
        setSearchResults([]);
      }
    } else {
      setSearchResults([]);
      setShowResults(false);
    }
  };

  // Handle address selection
  const handleAddressSelect = (result: any) => {
    const { y: lat, x: lng } = result;
    setPosition([lat, lng]);
    setMapCenter([lat, lng]);
    setFieldValue("co_ordinate", `${lat}, ${lng}`);

    setFieldValue("latitude", lat);
    setFieldValue("longitude", lng);
    setFieldValue("address_of_tfo", result.label || "");
    setSearchQuery(result.label || "");
    setShowResults(false);
  };

  return (
    <AppModal
      isOpen={isModalOpen}
      onClose={closeModal}
      closeOnOutsideClick={enableOutsideClick} // Enable/disable outside click close
    >
      <h2 className={CARD_TITLE}>
        {type === "edit" ? "Edit Device" : "Add Device"}
      </h2>

      <form onSubmit={handleSubmit} className="gap-4 flex flex-col items-start">
        <AnimatedInput
          placeholder="Device Name"
          {...getFieldProps("asset_name")}
          value={values.asset_name}
          isErrored={!!errors.asset_name}
          isTouched={!!touched.asset_name}
          errorMessage={errors.asset_name}
        />
        <AnimatedInput
          placeholder="Device Description (Optional)"
          {...getFieldProps("description")}
          value={values.description}
          isErrored={!!errors.description}
          isTouched={!!touched.description}
          errorMessage={errors.description}
        />

        <AppSelect2
          {...getFieldProps("asset_type")}
          name="asset_type"
          value={values.asset_type}
          isErrored={!!errors.asset_type}
          isTouched={!!touched.asset_type}
          errorMessage={errors.asset_type}
          label="Asset Type"
          options={assetTypeOptions}
        />
        <AnimatedInput
          placeholder="Asset Capacity (kVA)"
          {...getFieldProps("asset_capacity")}
          isErrored={!!errors.asset_capacity}
          isTouched={!!touched.asset_capacity}
          errorMessage={errors.asset_capacity}
          type={TextInputType.NUMBER}
        />
        <AnimatedInput
          placeholder="Gateway Serial"
          {...getFieldProps("gateway_serial")}
          isErrored={!!errors.gateway_serial}
          isTouched={!!touched.gateway_serial}
          errorMessage={errors.gateway_serial}
        />
        <AnimatedInput
          placeholder="Tariff"
          {...getFieldProps("tariff")}
          isErrored={!!errors.tariff}
          isTouched={!!touched.tariff}
          errorMessage={errors.tariff}
          type={TextInputType.NUMBER}
        />
        <YearPicker
          value={values.transformer_year}
          isErrored={!!errors.transformer_year}
          isTouched={!!touched.transformer_year}
          errorMessage={errors.transformer_year}
          label="Year of Manufacture"
          setFieldValue={(date: any) =>
            setFieldValue("transformer_year", transformDateToYear(date))
          }
        />
        <AppSelect2
          {...getFieldProps("zone_id")}
          name="zone_id"
          value={values.zone_id}
          isErrored={!!errors.zone_id}
          isTouched={!!touched.zone_id}
          errorMessage={errors.zone_id || zoneDataError}
          label="Asset Zone"
          options={[{value: '', label: 'Select Zone'}, ...transformedZoneData]}
        />
        <AnimatedInput
          placeholder="Type of Position"
          {...getFieldProps("type_of_position")}
          isErrored={!!errors.type_of_position}
          isTouched={!!touched.type_of_position}
          errorMessage={errors.type_of_position}
        />
        <AnimatedInput
          placeholder="Nature of Transformer"
          {...getFieldProps("nature_of_transformer")}
          isErrored={!!errors.nature_of_transformer}
          isTouched={!!touched.nature_of_transformer}
          errorMessage={errors.nature_of_transformer}
        />
        <AnimatedInput
          placeholder="Nature of Position"
          {...getFieldProps("nature_of_position")}
          isErrored={!!errors.nature_of_position}
          isTouched={!!touched.nature_of_position}
          errorMessage={errors.nature_of_position}
        />

        <AnimatedInput
          placeholder="Address of TFO"
          {...getFieldProps("address_of_tfo")}
          isErrored={!!errors.address_of_tfo}
          isTouched={!!touched.address_of_tfo}
          errorMessage={errors.address_of_tfo}
        />
        <AnimatedInput
          placeholder="Co-ordinate"
          // {...getFieldProps("co_ordinate")}
          onChange={(e: any) => handleCoordinateInput(e.target.value)}
          value={`${values.latitude}, ${values.longitude}`}
          isErrored={!!errors.latitude || !!errors.longitude}
          isTouched={!!touched.latitude || !!touched.longitude}
          errorMessage={errors.latitude}
        />

        <div className="flex flex-col w-full gap-4 p-4 rounded-lg border border-primary-border">
          {/* Address Search Input */}
          <div className="w-full relative">
            <input
              type="text"
              placeholder="Search for address..."
              value={searchQuery}
              onChange={(e) => handleAddressSearch(e.target.value)}
              className="w-full p-2 border border-primary-border rounded-md placeholder:text-sm h-[2rem] focus:outline-none"
            />
            {showResults && searchResults.length > 0 && (
              <div
                ref={searchContainerRef}
                className="absolute z-10 bottom-full w-full bg-white border border-gray-300 mb-1 max-h-60 overflow-y-auto rounded-md shadow-lg"
              >
                {searchResults.map((result, index) => (
                  <div
                    key={index}
                    className="p-2 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleAddressSelect(result)}
                  >
                    {result.label}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Map Section */}
          <div className="w-full h-64">
            <MapContainer
              center={mapCenter}
              zoom={13}
              className="h-full w-full"
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <LocationMarker
                setFieldValue={setFieldValue}
                position={position}
                setPosition={setPosition}
              />
              <MapCenterUpdater center={mapCenter} />
            </MapContainer>
          </div>
        </div>
        <AppToggleInput
          {...getFieldProps("is_active")}
          name="is_active"
          onChange={(value: boolean) => setFieldValue("is_active", value)}
          value={values.is_active}
          label="Device Status"
        />
        <AppButton
          className={"w-full mt-4"}
          text={
            isSubmitting ? "" : type === "edit" ? "Save Changes" : "Add Device"
          }
          loader={{ loading: isSubmitting, height: 4, width: 4 }}
          type={ButtonType.PRIMARY}
          handleClick={handleSubmit}
          disabled={isSubmitting}
        />
      </form>
    </AppModal>
  );
}

export default AddDeviceModal;
